class AcRewardsForm {
  constructor() {
    this.dwlDateFrom = null;
    this.dwlDateTo = null;
    this.limit = null;
    this.page = null;
    this.search = null;
    this.orderBy = null;
    this.precision = null;
    this.periods = null;
    this.currency = null;
    this.turnoverWinLossCommission = null;
    this.totals = null;
    this.filterRevenueShare = null;
    this.sort = null;
  }

  toPayload() {
    return {
      dwlDateFrom: this.dwlDateFrom,
      dwlDateTo: this.dwlDateTo,
      limit: this.limit,
      page: this.page,
      search: this.search,
      orderBy: this.orderBy,
      precision: this.precision,
      filterRevenueShare: this.filterRevenueShare,
      sort: this.sort
    };
  }
};

export default AcRewardsForm;



// WEBPACK FOOTER //
// ./client/app/pages/acrewards/model/form.model.js